import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_SHARE_ENGAGEMENT_ACCESS_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_SHARE_ENGAGEMENT_ACCESS_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/OpenShareEngagementAccessModal')
};